import { render, staticRenderFns } from "./parameters.vue?vue&type=template&id=28a852ca"
import script from "./parameters.vue?vue&type=script&lang=ts"
export * from "./parameters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports